import { useState, useRef } from 'react';
import CardContent from './CardContent';

export default function Card({ currentCard, getRandomCard, cards }) {
  const [flipStatus, setFlipStatus] = useState(false);

  const handleFlip = () => {
    cardRef.current.classList.toggle('flip');
    setFlipStatus(!flipStatus);
  };

  const cardRef = useRef(null);

  return (
    <section>
      <button onClick={handleFlip}>Flip the card</button>
      <button onClick={() => getRandomCard(cards)}>Change the card</button>

      <div className='card filtered' aria-live='assertive' ref={cardRef}>
        <CardContent currentCard={currentCard} flipStatus={flipStatus} />
      </div>
      <button onClick={() => cardRef.current.classList.toggle('filtered')}>
        Switch card between light and dark mode
      </button>
    </section>
  );
}
